module.exports = __webpack_public_path__ + "static/sf-map-contact-6ee98c8b534e6c908579bb6dee820545.jpg";